import { postJson } from '#/utils/http/postJson';

import type { UserDashboardApiGeneralSettings } from './types/UserDashboardApiGeneralSettings';

export async function userDashboardApiEnableProfileFeatures(): Promise<UserDashboardApiGeneralSettings> {
  return postJson<{
    generalSettings: UserDashboardApiGeneralSettings;
  }>('/data/userdashboard/profile/enable').then(
    ({ generalSettings }) => generalSettings,
  );
}
